// opervex-frontend/src/Opervex/System/index.js

import _Layouts from "./Layouts";
import _telephoneOperator from "./TelephoneOperator";
import _profile from "./Profile";
import _user from "./User";
import _userProfile from "./UserProfile";
import _tenant from "./Tenant";
import _operationGM from "./OperationGoodsMovement";
import _template from "./Template";
import _Setting from "./Setting";

class System {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.Layouts = new _Layouts(this.#_api);
    this.TelephoneOperator = new _telephoneOperator(this.#_api);
    this.Profile = new _profile(this.#_api);
    this.User = new _user(this.#_api);
    this.UserProfile = new _userProfile(this.#_api);
    this.Tenant = new _tenant(this.#_api);
    this.OperationGoodsMovement = new _operationGM(this.#_api);
    this.Template = new _template(this.#_api);
    this.Setting = new _Setting(this.#_api);
  }
}

export default System;
